import React from 'react';
import PropTypes from 'prop-types';

function SmallSemiTruckIcon({ className, fill }) {
	return (
		<svg className={className} width="23px" height="23px" viewBox="0 0 10 10" xmlns="http://www.w3.org/2000/svg" >
			<path fill={fill} fillRule="nonzero" d="M3.139 0a.832.832 0 0 0-.804.618l-.163.608c-.3.177-.52.479-.592.833l-.322 1.61-.008.081v1.667l-.373.186a.833.833 0 0 0-.46.745v1.569a.83.83 0 0 0 .416.717v.533a.833.833 0 1 0 1.667 0V8.75h5v.417a.833.833 0 1 0 1.667 0v-.533a.83.83 0 0 0 .416-.717V6.348a.833.833 0 0 0-.46-.745l-.373-.186V3.75 3.75l-.008-.081-.322-1.61a1.257 1.257 0 0 0-.592-.833L7.665.618A.833.833 0 0 0 6.86 0H3.14zM5 1.667c1.142 0 1.885.128 2.308.236a.411.411 0 0 1 .295.32l.306 1.527H2.09l.306-1.528a.41.41 0 0 1 .295-.32c.423-.107 1.166-.235 2.308-.235zm-4.59.827a.417.417 0 0 0-.41.423v1.25a.417.417 0 1 0 .833 0v-1.25a.417.417 0 0 0-.423-.423zm9.167 0a.417.417 0 0 0-.41.423v1.25a.417.417 0 1 0 .833 0v-1.25a.417.417 0 0 0-.423-.423zm-5.41 2.09h1.666c.46 0 .834.372.834.833V7.5H3.333V5.417c0-.46.373-.834.834-.834zm-2.5 2.083h.416a.417.417 0 0 1 0 .833h-.416a.417.417 0 0 1 0-.833zm6.25 0h.416a.417.417 0 0 1 0 .833h-.416a.417.417 0 0 1 0-.833z" />
		</svg>
	);
}

SmallSemiTruckIcon.propTypes = {
	className: PropTypes.string,
	fill: PropTypes.string,
};

SmallSemiTruckIcon.defaultProps = {
	className: undefined,
	fill: '#fff',
};
export default SmallSemiTruckIcon;
